module.exports = __webpack_public_path__ + "_assets/img/Frame1196.9e48fb24.svg";